import loctypeMultipleTag from "./locTypeMultipleTag.vue";
export default loctypeMultipleTag;
